import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DriveEventService } from 'src/app/services/drive-event/drive-event.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-access-code-dialog',
  templateUrl: './access-code-dialog.component.html',
  styleUrls: ['./access-code-dialog.component.scss']
})
export class AccessCodeDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AccessCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public driveEventService: DriveEventService,
  ) { }

  driveName = new FormControl(' ', [Validators.required]);
  city = new FormControl('', [Validators.required]);
  companyShortName = new FormControl('', [Validators.required]);
  accessCode = new FormControl('', [Validators.required]);
  registrationLink = new FormControl('', [Validators.required]);


  isSubmit: boolean;
  todayDate = new Date();
  tomorrow = new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), (this.todayDate.getDate() + 1));
  dayAfterTomorrow = new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), (this.todayDate.getDate() + 2));
  threeMonth = new Date(this.todayDate.getFullYear(), (this.todayDate.getMonth() + 3), this.todayDate.getDate());
  drive: any;
  startDate: Date;
  endDate: Date;
  eventDate: Date;
  time: Date;
  copyRegLink: any;

  ngOnInit() {
    this.getData()
  }
  onCloseDialog() {
    this.dialogRef.close();
  }
  getData() {
    this.driveEventService.getDriveEvent().subscribe(
      (response: any) => {
        this.drive = response;
      });
  }
  copy() {
    this.copyRegLink = this.drive.regLink
  }
}



// import { Component, OnInit, Inject } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// import { DriveEventService } from 'src/app/services/drive-event/drive-event.service';
// import {  Validators, FormControl } from '@angular/forms';

// @Component({
//   selector: 'app-access-code-dialog',
//   templateUrl: './access-code-dialog.component.html',
//   styleUrls: ['./access-code-dialog.component.scss']
// })
// export class AccessCodeDialogComponent implements OnInit {

//   constructor(
//     public dialogRef: MatDialogRef<AccessCodeDialogComponent>,
//     @Inject(MAT_DIALOG_DATA)private data:any,
//     public driveEventService:DriveEventService,
//   ) { }

//   driveName = new FormControl('', [Validators.required,Validators.pattern('^[a-zA-Z ]*$')]);
//   city = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
//   companyShortName = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
//   accessCode = new FormControl('', [Validators.required]);
//   registrationLink = new FormControl('', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]);
//   startDate:Date;
//   endDate:Date;
//   eventDate:Date;
//   time:Date;
//  copyRegLink:any;

// isSubmit:boolean;
// todayDate=new Date();
// tomorrow=new Date(this.startDate.getFullYear(), this.startDate.getMonth(), (this.startDate.getDate() + 1));
// dayAfterTomorrow=new Date(this.endDate.getFullYear(), this.endDate.getMonth(), (this.endDate.getDate() + 1));
// threeMonth=new Date(this.todayDate.getFullYear(), (this.todayDate.getMonth() + 3), this.todayDate.getDate() );
// drive:any;


//   ngOnInit() {
//     this.getData()
//    this.city=this.data.city
//   }
//   onCloseDialog(){
//     this.dialogRef.close();

//   }
//   getErrorMessageOfDriveName(){
//     return this.driveName.hasError('required') ? 'Enter drive name' : 
//     this.driveName.hasError('pattern') ? 'Enter alphabates value only' : '';
//   }

//   getErrorMessageOfCity(){
//     return this.city.hasError('required') ? 'Enter city' : 
//     this.city.hasError('pattern') ? 'Enter alphabates value only' : '';
//   }
//   getData(){
//     this.driveEventService.getDriveEvent().subscribe(
//       (response:any)=>{
//        this.drive=response;
//        this.driveName=this.drive.companyName;

//    });
//   }


//   copy(){
//     this.copyRegLink= this.drive.regLink

//   }
// }

//  this.companyShortName=this.drive.companyShortName;